import { COVERGO_SAAS_DEV } from "../consts.js"

export const gms_dev = {
	"gms-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "gms_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
